import * as React from 'react';
import styled from 'styled-components';
import { AutoCompleteOption } from './AutoCompleteOption';

interface IState {

}

export interface IPropsAutoCompleteOptionList {
  optionList: Array<any>;
  nameAsValue: boolean;
  focus: boolean;
  themeColor: string;
  onItemSelected: any;
  selectedItem: number;
}

const StyledAutoCompleteOptionList = styled.ul<{
  focus: boolean | undefined,
  themeColor: string,
  optionList: Array<any>,
}>
`
  font-size: ${props => props.theme.defaultFontSize};
  font-family: ${props => props.theme.fontFamily};
  ${props => {
    if(!props.focus || props.optionList.length<=0)
      return 'display: none;';
    else
      return '';
  }}
  position: absolute;
  z-index: 2;
  background-color: white;
  width: 100%;
  top: 8px;
  box-sizing: border-box;
  max-height: 150px;
  overflow-y: scroll;
  list-style: none;
  padding: 0;
  border: 1px solid ${props => {return props.theme[props.themeColor] ;}};
`;

export class AutoCompleteOptionList extends React.Component<Partial<IPropsAutoCompleteOptionList>, IState> {
  constructor(props: IPropsAutoCompleteOptionList) {
    super(props);
  }
  render (){
    return (
      <StyledAutoCompleteOptionList
        focus={this.props.focus}
        themeColor={this.props.themeColor?this.props.themeColor:'primaryColor'}
        optionList={this.props.optionList!}
      >
        {this.props.optionList ? this.props.optionList.map(opt =>
          <AutoCompleteOption
            label={opt.label}
            value={opt.value}
            key={opt.value}
            focus={this.props.focus}
            themeColor={this.props.themeColor?this.props.themeColor:'primaryColor'}
            onClick={this.props.onItemSelected}
            selected={
              opt.value == (
                this.props.selectedItem != undefined
                  ? this.props.selectedItem
                  : ''
              )
            }
          >
            {opt.label}
          </AutoCompleteOption>
        ):''}
      </StyledAutoCompleteOptionList>
    );
  }
}
